export enum DatePickerViewTypeEnum {
  Month = 'month',
  Year = 'year',
  MultiYear = 'multi-year',
}
